import React from "react";
import "react-moment";
import './MovimientosConAI.css'

class MovimientosConAI extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            telefonoSoporte: "+51933386658",
            isHovered: false,
            isPulsing: true,
            showContactOptions: false,
            isCardFlipped: false
        };
    }

    componentDidMount() {
        // Iniciar pulso intermitente
        this.pulseInterval = setInterval(() => {
            this.setState(prevState => ({ isPulsing: !prevState.isPulsing }));
        }, 2000);
    }

    componentWillUnmount() {
        if (this.pulseInterval) {
            clearInterval(this.pulseInterval);
        }
    }

    redirigirWhatsApp = () => {
        const { telefonoSoporte } = this.state;
        const mensaje = encodeURIComponent("Hola, necesito información sobre el modulo Movimientos con AI.");
        const url = `https://wa.me/${telefonoSoporte}?text=${mensaje}`;
        
        // Efecto de clic
        this.setState({ isHovered: false });
        
        // Pequeño retraso para ver la animación
        setTimeout(() => {
            window.open(url, '_blank');
        }, 300);
    }

    toggleContactOptions = () => {
        this.setState(prevState => ({
            showContactOptions: !prevState.showContactOptions
        }));
    }

    flipCard = () => {
        this.setState(prevState => ({
            isCardFlipped: !prevState.isCardFlipped
        }));
    }

    render() {
        const { isHovered, isPulsing, showContactOptions, isCardFlipped } = this.state;

        return (
            <>
                <div className="text-center py-5">
                    {/* Icono animado */}
                    <div className="mb-4 position-relative">
                        <div 
                            className={`d-inline-block ${isPulsing ? 'pulse-animation' : ''}`}
                            style={{
                                position: 'relative',
                                animation: isPulsing ? 'pulse 2s infinite' : 'none'
                            }}
                        >
                            <i 
                                className="fas fa-robot fa-4x mb-3" 
                                style={{ 
                                    color: '#01A59C',
                                    filter: `drop-shadow(0 0 ${isPulsing ? '15px' : '8px'} rgba(1, 165, 156, ${isPulsing ? '0.7' : '0.4'}))`,
                                    transition: 'all 0.3s ease'
                                }}
                            ></i>
                        </div>
                        
                        {/* Partículas flotantes */}
                        <div className="floating-particles">
                            {[1, 2, 3, 4, 5].map(i => (
                                <div 
                                    key={i}
                                    className="particle"
                                    style={{
                                        animationDelay: `${i * 0.3}s`,
                                        left: `${20 * i}%`
                                    }}
                                ></div>
                            ))}
                        </div>
                    </div>

                    <h4 className="text-muted mb-3 slide-in">Movimientos de compras con AI</h4>
                    <p className="text-muted mb-4 fade-in">
                        Actualmente no tienes acceso para este módulo. Para más información, 
                        comunícate con nuestro equipo de soporte.
                    </p>

                    {/* Tarjeta con efecto flip - VERSIÓN SIMPLIFICADA */}
                    <div 
                        className="mx-auto" 
                        style={{ 
                            maxWidth: '400px',
                            height: '300px',
                            perspective: '1000px'
                        }}
                    >
                        <div 
                            className="position-relative w-100 h-100"
                            style={{
                                transition: 'transform 0.6s',
                                transformStyle: 'preserve-3d',
                                transform: isCardFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
                            }}
                        >
                            {/* Frente de la tarjeta */}
                            <div 
                                className="position-absolute w-100 h-100"
                                style={{
                                    backfaceVisibility: 'hidden',
                                    WebkitBackfaceVisibility: 'hidden'
                                }}
                            >
                                <div className="card border-0 shadow-sm h-100" style={{
                                    backgroundColor: 'white',
                                    borderRadius: '15px',
                                    overflow: 'hidden'
                                }}>
                                    <div className="card-body d-flex flex-column justify-content-center">
                                        <button 
                                            className="btn btn-link position-absolute"
                                            style={{ top: '10px', right: '10px', color: '#01A59C' }}
                                            onClick={this.flipCard}
                                            title="Ver información del módulo"
                                        >
                                            <i className="fas fa-info-circle"></i>
                                        </button>
                                        
                                        <h5 
                                            className="card-title mb-3 glow-text"
                                            style={{ color: '#01A59C' }}
                                        >
                                            <i className="fas fa-headset me-2"></i>
                                            Soporte Técnico
                                        </h5>
                                        <p className="card-text mb-4">
                                            ¿Necesitas ayuda con los reportes o tienes preguntas específicas?
                                        </p>
                                        
                                        <button 
                                            className={`btn btn-lg w-100 ${isHovered ? 'btn-hover' : ''}`}
                                            onClick={this.redirigirWhatsApp}
                                            onMouseEnter={() => this.setState({ isHovered: true })}
                                            onMouseLeave={() => this.setState({ isHovered: false })}
                                            style={{
                                                backgroundColor: isHovered ? '#028e86' : '#01A59C',
                                                borderColor: isHovered ? '#028e86' : '#01A59C',
                                                borderRadius: '25px',
                                                color: 'white',
                                                transition: 'all 0.3s ease',
                                                transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
                                                boxShadow: isHovered ? '0 8px 20px rgba(1, 165, 156, 0.4)' : '0 4px 10px rgba(1, 165, 156, 0.2)'
                                            }}
                                        >
                                            <i className="fab fa-whatsapp me-2"></i>
                                            Contactar por WhatsApp
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Reverso de la tarjeta */}
                            <div 
                                className="position-absolute w-100 h-100"
                                style={{
                                    backfaceVisibility: 'hidden',
                                    WebkitBackfaceVisibility: 'hidden',
                                    transform: 'rotateY(180deg)',
                                    backgroundColor: '#f8f9fa',
                                    borderRadius: '15px',
                                    padding: '20px',
                                    overflow: 'auto'
                                }}
                            >
                                <div className="h-100 d-flex flex-column">
                                    <button 
                                        className="btn btn-link align-self-start"
                                        style={{ color: '#01A59C', marginBottom: '15px' }}
                                        onClick={this.flipCard}
                                        title="Volver al soporte"
                                    >
                                        <i className="fas fa-arrow-left me-1"></i>
                                        Volver
                                    </button>
                                    
                                    <div className="flex-grow-1">
                                        <h5 style={{ color: '#01A59C' }}>
                                            <i className="fas fa-info-circle me-2"></i>
                                            Información del Módulo
                                        </h5>
                                        <p className="small mt-3">
                                            Este módulo utiliza inteligencia artificial para analizar y optimizar tus movimientos de compras.
                                        </p>
                                        <ul className="text-start small ps-3">
                                            <li className="mb-2">
                                                <i className="fas fa-chart-line text-success me-2"></i>
                                                Análisis predictivo de compras
                                            </li>
                                            <li className="mb-2">
                                                <i className="fas fa-lightbulb text-warning me-2"></i>
                                                Recomendaciones inteligentes
                                            </li>
                                            <li className="mb-2">
                                                <i className="fas fa-file-alt text-info me-2"></i>
                                                Reportes automatizados
                                            </li>
                                            <li className="mb-2">
                                                <i className="fas fa-robot text-primary me-2"></i>
                                                Detección de patrones con AI
                                            </li>
                                            <li>
                                                <i className="fas fa-bolt text-danger me-2"></i>
                                                Optimización en tiempo real
                                            </li>
                                        </ul>
                                        
                                        <div className="mt-4 p-3 rounded" style={{ backgroundColor: 'rgba(1, 165, 156, 0.1)' }}>
                                            <small className="d-block mb-1">
                                                <i className="fas fa-lock me-1"></i>
                                                Acceso requerido: <strong>Plan Premium</strong>
                                            </small>
                                            <small className="d-block">
                                                <i className="fas fa-calendar-alt me-1"></i>
                                                Disponible desde: <strong>Próxima actualización</strong>
                                            </small>
                                        </div>
                                    </div>
                                    
                                    <div className="mt-3">
                                        <small className="text-muted">
                                            <i className="fas fa-question-circle me-1"></i>
                                            ¿Interesado en este módulo?
                                        </small>
                                        <br/>
                                        <button 
                                            className="btn btn-sm mt-2"
                                            style={{
                                                backgroundColor: '#01A59C',
                                                color: 'white',
                                                border: 'none',
                                                padding: '5px 15px',
                                                borderRadius: '20px',
                                                margin: '5px'
                                            }}
                                            onClick={() => {
                                                this.flipCard();
                                                setTimeout(() => {
                                                    this.redirigirWhatsApp();
                                                }, 300);
                                            }}
                                        >
                                            Solicitar acceso
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    {/* Información adicional con animación */}
                    <div className="mt-4 fade-in-delayed">
                        <div className="mt-3 text-muted small bounce-in">
                            <i className="fas fa-clock me-1"></i>
                            Horario de atención: Lunes a Viernes 8:30 AM - 7:30 PM
                        </div>
                    </div>

                    {/* Indicador de carga simulado */}
                    <div className="mt-4">
                        <div className="progress" style={{ height: '8px', maxWidth: '300px', margin: '0 auto' }}>
                            <div 
                                className="progress-bar progress-bar-striped progress-bar-animated"
                                style={{ 
                                    backgroundColor: '#01A59C',
                                    width: '100%'
                                }}
                            ></div>
                        </div>
                        <small className="text-muted">Módulo en desarrollo - Disponible pronto</small>
                    </div>
                </div>
            </>
        )
    }
}

export default MovimientosConAI;